import { Routes } from '@angular/router';

import { proWebsiteRedirectGuard } from 'src/providers/guard/pro-website-redirect.guard';

export const redirects: Routes = [
  // Old home links open the property dashboard: /properties for rental accounts, /overview for the rest.
  { path: 'manage-addresses', redirectTo: 'properties', pathMatch: 'full'},
  { path: 'no-plan', redirectTo: 'properties', pathMatch: 'full'},
  { path: 'my-cleanings', redirectTo: 'properties', pathMatch: 'full'},
  { path: 'home', redirectTo: 'properties', pathMatch: 'full'},
  { path: 'account', redirectTo: 'properties', pathMatch: 'full'},
  { path: 'homekeeper-options', redirectTo: 'properties', pathMatch: 'full'},
  { path: 'homekeeper', redirectTo: 'properties', pathMatch: 'full'},
  { path: 'update-payment-info', redirectTo: 'payment-methods', pathMatch: 'full'},
  { path: 'dashboard', redirectTo: 'properties', pathMatch: 'full'},
  // Old addresses of pages renamed to match their labels.
  { path: 'inventory', redirectTo: 'restocking', pathMatch: 'full'},
  { path: 'teams', redirectTo: 'groups', pathMatch: 'full'},
  { path: 'marketing', redirectTo: 'revenue', pathMatch: 'full'},
  { path: 'overview/add-report', redirectTo: 'reports/add-report', pathMatch: 'full'},
  { path: 'overview/edit-report-column', redirectTo: 'reports/edit-report-column', pathMatch: 'full'},
  { path: 'overview/edit-report-name', redirectTo: 'reports/edit-report-name', pathMatch: 'full'},
  { path: 'overview/report-settings/:dashboard_customer_report_id', redirectTo: 'reports/report-settings/:dashboard_customer_report_id', pathMatch: 'full'},
  { path: 'marketing/channel-detail', redirectTo: 'revenue/listing-detail', pathMatch: 'full'},
  { path: 'marketing/review-detail', redirectTo: 'revenue/review-detail', pathMatch: 'full'},
  { path: 'marketing/leave-guest-review', redirectTo: 'revenue/leave-guest-review', pathMatch: 'full'},
  { path: 'marketing/listing-optimization-select', redirectTo: 'revenue/listing-optimization-select', pathMatch: 'full'},
  { path: 'team/:teamId', redirectTo: 'group/:teamId', pathMatch: 'full'},
  // The rental Overview tab (P&L) was /strategy before it moved to /overview.
  { path: 'strategy', redirectTo: 'overview', pathMatch: 'full'},
  { path: 'pricing', redirectTo: 'optimizer', pathMatch: 'full'},
  { path: ':url_suffix/client/:client_hub_uuid', redirectTo: 'client/:client_hub_uuid', pathMatch: 'full'}
]

// Goes after every page and redirect: an unknown /<name> may be a pro's website link.
export const proWebsiteRoutes: Routes = [
  { path: ':url_suffix', canActivate: [proWebsiteRedirectGuard], children: []}
]
